import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';

export class AppConfig { 
    public static app_version=environment.appVersion;
    public static API_ENDPOINT= environment.API_ENDPOINT;
    public static gis_configuration= environment.gis_configuration;
    public static debug_showid=false;
    public static versionCheckInterval=300000;
    //when use root folder
    //public static API_ENDPOINT='';    

    public static API_TIMEOUT:number=30000;
    public static API_TIMEOUT_MED:number=40000;
    public static API_TIMEOUT_HIGH:number=90000;
    public static API_TIMEOUT_MAX:number=160000;

    public static API_DATE_FORMAT:string="mm-dd-yyyy";//no se usa

    public static httpOptions = {
      body:null,
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    public static ROUTE_SOLAR:string="solar";
    /**
     * save configuration
     */
    public static saveConfiguration(){
      let cfg={
        app_version:AppConfig.app_version
        ,API_DATE_FORMAT:AppConfig.API_DATE_FORMAT
        ,gis_configuration: AppConfig.gis_configuration

      };
      localStorage.setItem('esolar-config', JSON.stringify(cfg));
    }
    /**
     * restore configuration
     */
    public static restoreConfiguration(){

      let cfg:any=localStorage.getItem('esolar-config' );
      try{
        if (!cfg) {
          return;
        }
  
        cfg = JSON.parse(cfg);     
        console.log("CONFIGURATION RESTORED", cfg) 
        //AppConfig.app_version=cfg.appVersion;
        AppConfig.API_DATE_FORMAT= cfg.API_DATE_FORMAT;
        AppConfig.gis_configuration= cfg.gis_configuration;
      }
      catch(error){
        console.error("Error loading configuration ",error);
      }

    }    
   
  }


